import { CoreIcon } from '../core-icon';
import gasStationColorSVG from '../../assets/icons/gas-station-color.svg';
import type { IconProps } from '../core-icon';

export const GasStationColorIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={gasStationColorSVG} {...props} />;
};
